import React, { useState } from "react";
import { Slide } from "@progress/kendo-react-animation";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";
import { NotificationGroup } from "@progress/kendo-react-notification";
import { MessageDetailsModal } from "../../components/coobjects/MessageDetailsModal";
import NotificationItem from "./NotificationItem";
import { NotificationToast } from "./NotificationManager";

const classNames = mergeStyleSets({
  notificationGroup: {
    right: 0,
    bottom: 0,
    alignItems: "flex-start",
    padding: "0 1rem",
  },
});

interface NotificationItemProps {
  notifications: NotificationToast[];
  onRequestHide: (notification) => void;
}

const NotificationsDetails: React.FunctionComponent<NotificationItemProps> = (props) => {
  const { notifications, onRequestHide } = props;

  const [showModal, setShowModal] = useState(false);
  const [details, setDetails] = useState([]);

  const showModalDetails = (input, n: NotificationToast) => {
    setShowModal(true);
    setDetails(input);
    onRequestHide(n);
  };

  function hide() {
    setShowModal(false);
  }

  return (
    <>
      <MessageDetailsModal details={details} isModalOpen={showModal} onHide={hide} />
      <NotificationGroup className={classNames.notificationGroup}>
        {notifications.map((n) => (
          <Slide direction={"up"} key={n.key}>
            <NotificationItem
              notification={n}
              showModalDetails={(e) => showModalDetails(e, n)}
              onHide={onRequestHide}
            />
          </Slide>
        ))}
      </NotificationGroup>
    </>
  );
};
export default NotificationsDetails;
